/**
 * The single in-memory holder for the current session's ACCESS token. Deliberately NOT React state —
 * Apollo's authLink and the axios interceptor run outside the render tree and need a synchronous
 * getter (docs/development/FrontendGuidelines.md §6.2 point 3).
 *
 * The REFRESH token is never held here (or anywhere in JS) — for the web client it lives only in the
 * backend's `HttpOnly` cookie (ADR-0006), invisible to JavaScript. Per §4.4/§6.4 the access token is
 * likewise never written to localStorage/sessionStorage/cookies; this module is the only place it
 * exists client-side, and it is cleared on tab close/reload by design.
 */

let accessToken: string | null = null;

export function getAccessToken(): string | null {
  return accessToken;
}

export function setTokens(token: string): void {
  accessToken = token;
}

export function clearTokens(): void {
  accessToken = null;
}
